import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const WhyStructuredThinkingMattersSection = ({ heading, accentIndex = 0, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="why-structured-thinking-matters"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Every day, thousands of thoughts pass through our minds. Some help us solve problems. Others
      create confusion, stress, and unnecessary worry.
    </GuideLead>
    <p className="guide-panel__p">
      The difference is not how much we think. It is <strong>how we think</strong>.
    </p>
    <p className="guide-panel__p">
      Structured thinking is a simple framework that helps you organize your thoughts, separate facts
      from assumptions, and make better decisions. It gives your mind a process to follow instead of
      allowing emotions, fears, or stories to take control.
    </p>
    <GuideCardGrid columns={2}>
      <GuideCard
        iconKey="thinking"
        title="The goal is not to stop thinking"
        description="Thinking is essential. The aim is to think with purpose."
      />
      <GuideCard
        iconKey="clarity"
        title="The goal is to think with clarity"
        description="Structure turns scattered thoughts into focused, productive thinking."
      />
    </GuideCardGrid>
    <GuideCallout variant="amber">
      The goal is not to stop thinking. The goal is to think with clarity.
    </GuideCallout>
  </GuidePanel>
);

export default WhyStructuredThinkingMattersSection;
